<template>
  <div class="about">
    <div class="md-layout">
      <div
        class="md-layout-item md-size-100 md-layout cover md-alignment-center-center"
        :style="{ 'background-image' : getUrlCover() }"
      >
        <div class="md-layout coverItem md-alignment-center-center">
          <div class="md-layout-item coverText md-size-100 centerAlign">
            Rêve de ta vie en couleur
            <br />C’est le secret du bonheur
          </div>
        </div>
      </div>
      <div class="md-layout-item md-size-100 md-layout" :style="altBg">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 meTitle">Qui suis-je ?</div>
          <div class="md-layout-item md-size-100 meDesc ql-editor" v-html="getMyDataContent.desc"></div>
        </div>
        <div class="md-layout-item md-size-100 btnHolder">
          <md-button class="md-primary md-raised" @click="goToMe()">ME DECOUVRIR</md-button>
        </div>
      </div>

      <div class="md-layout-item md-size-100 meTitle">Timeline</div>
      <div class="md-layout-item md-size-100">
        <timeline :timeline="getTimeline"></timeline>
      </div>
      <div :style="altBg">
        <div class="md-layout-item md-size-100 meTitle">Derniers articles</div>
        <div class="md-layout-item md-size-100 md-layout md-alignment-center lastArticleContainer">
          <div
            :key="a.title"
            v-for="a in getLastArticles"
            class="md-layout-item md-layout md-large-size-70 md-small-size-90 lastArticleObject"
            @click="onArticleClick(a)"
          >
            <div
              class="md-layout-item md-large-size-50 md-small-size-100 adventureImage lastArticleImage"
              :style="{ 'background-image' : getUrl(a) }"
            ></div>
            <div class="md-layout-item md-large-size-50 md-small-size-100 adventureMiniContent">
              <div class="contentTitle">
                <div class="contentDate">{{toDate(a.date)}}</div>
                <b>{{a.title}}</b>
              </div>
              <div class="contentBody">{{a.desc}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import timeline from "./Timeline";
import { mapGetters, mapActions } from "vuex";
import * as moment from "moment";
moment.locale("fr");
// import VueInstagram from "vue-instagram";
export default {
  name: "home",
  components: {
    timeline
  },
  computed: {
    altBg() {
      return {
        color: this.getTextColor,
        backgroundColor: this.getBgColor
      };
    },
    ...mapGetters([
      "getTimeline",
      "getLastArticles",
      "getMyDataContent",
      "getBgColor",
      "getTextColor"
    ])
  },
  mounted: function() {
    // this.altBg.color = this.getTextColor;
    // this.altBg.backgroundColor = this.getBgColor;
  },
  methods: {
    ...mapActions(["setCurrentArticle"]),
    onArticleClick(a) {
      this.setCurrentArticle(a);
      this.$router.push("/article");
    },
    goToMe() {
      this.$router.push("/me");
    },
    toDate(ms) {
      return moment(ms).format("Do MMM YY");
    },
    getUrl(c) {
      return `url('${c.image}')`;
    },
    getUrlCover() {
      return `url('${this.getMyDataContent.url}')`;
    }
  }
};
</script>

<style >
.lastArticleContainer {
  height: auto;
}
.altBg {
  background-color: #f5f3e3;
}
.lastArticleObject {
  height: 150px;
  margin: 20px !important;
  cursor: pointer;
}
.lastArticle {
  height: 150px;
}
.cover {
  height: 500px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

.coverItem {
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 15%,
    rgba(0, 0, 0, 0.7) 80%
  );
  height: 500px;
  font-size: 40px;
}

.polaImg {
  height: 25vw;
  width: 25vw;
  margin-top: 3vw;
  background-image: url("https://picsum.photos/id/296/300/200");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.polaText {
  color: black;
}

.polaHolder {
  background-color: white;
}

.categoryHeader {
  padding: 20px;
  font-size: 30px;
}

.meTitle {
  font-size: 40px;
  padding: 20px;
  text-align: center;
  font-weight: bold;
  margin: 80px;
}
.meDesc {
  padding-left: 100px !important;
  padding-right: 100px !important;
  font-size: 25px;
  text-align: justify !important;
}

.btnHolder {
  text-align: center;
  margin: 30px;
}

.coverText {
  line-height: 50px;
}

.centerAlign {
  text-align: center;
  vertical-align: end;
}

@media only screen and (max-width: 959px) {
  /* For mobile phones: */
  .meDesc {
    padding-left: 10px !important;
    padding-right: 10px !important;
    font-size: 20px;
    text-align: justify !important;
  }

  .lastArticleObject {
    height: auto;
    margin: 10px !important;
    cursor: pointer;
  }
  .lastArticle {
    height: auto;
  }

  .lastArticleImage {
    height: 100px;
  }

  .centerAlign {
    font-size: 24px;
  }
}
</style>
